import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-80">
      <ScrollToTop data-id="element-81" />
      <Header data-id="element-82" />
      <main className="flex-grow" data-id="element-83">{children}</main>
      <Footer data-id="element-84" />
    </div>;
}